import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import { EVENTS_PATH, CONTRACTS_PATH } from '../constants/routes';
import { currentUserSelector } from '../selectors/authentication';
import { PERMISSIONS, hasPermissions } from '../constants/authentication/permissions';

class Home extends Component {
    render() {
        const viewEvents = hasPermissions(this.props.currentUser, PERMISSIONS.VIEW_LINEUP);
        const viewContracts =
            hasPermissions(this.props.currentUser, PERMISSIONS.VIEW_CONTRACTS_INBOX) ||
            hasPermissions(this.props.currentUser, PERMISSIONS.VIEW_SIGNED_CONTRACTS_INBOX);
        if (viewEvents) {
            return <Redirect to={EVENTS_PATH} />;
        } else if (viewContracts) {
            return <Redirect to={CONTRACTS_PATH} />;
        } else {
            return (
                <div className="ckp-errors">
                    <h1 className="ckp-errors-title">Nothing to see here.</h1>
                    <h2 className="ckp-errors-subtitle">
                        Please contact <a href="mailto:techsupport@clearem.tv">Clear'em support</a>, if you think this
                        is an error.
                    </h2>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    currentUser: currentUserSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js